// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table-tableContainer-QgrKY","horizontalScroll":"Table-horizontalScroll-pEqaG","table":"Table-table-uAtH3"};